export const leaderboard = {
  en: {
    header: 'Family Progress',
    subtitle: 'See how your circle is growing',
    scope: 'Your Circle',
    timePeriod: 'Time Period',
    global: 'Global',
    church: 'Church',
    family: 'Family',
    friends: 'Friends',
    alltime: 'All Time',
    weekly: 'Weekly',
    loading: 'Loading...',
    anonymous: 'Anonymous',
    noScoresYet: 'No scores yet',
    errorLoading: 'Error loading leaderboard',
  },
  es: {
    header: 'Tabla de posiciones',
    subtitle: 'Mira cómo crece tu círculo',
    scope: 'Tu círculo',
    timePeriod: 'Período de tiempo',
    global: 'Global',
    church: 'Iglesia',
    family: 'Familia',
    friends: 'Amigos',
    alltime: 'Todo el tiempo',
    weekly: 'Semanal',
    loading: 'Cargando...',
    anonymous: 'Anónimo',
    noScoresYet: 'Aún sin puntuaciones',
    errorLoading: 'Error al cargar clasificación',
  },
  fr: {
    header: 'Tableau des scores',
    subtitle: 'Voyez comment votre cercle progresse',
    scope: 'Votre cercle',
    timePeriod: 'Période',
    global: 'Global',
    church: 'Église',
    family: 'Famille',
    friends: 'Amis',
    alltime: 'Tous les temps',
    weekly: 'Hebdomadaire',
    loading: 'Chargement...',
    anonymous: 'Anonyme',
    noScoresYet: 'Aucun score pour le moment',
    errorLoading: 'Erreur de chargement du classement',
  },
  de: {
    header: 'Bestenliste',
    subtitle: 'Sieh, wie dein Kreis wächst',
    scope: 'Dein Kreis',
    timePeriod: 'Zeitraum',
    global: 'Global',
    church: 'Kirche',
    family: 'Familie',
    friends: 'Freunde',
    alltime: 'Alle Zeiten',
    weekly: 'Wöchentlich',
    loading: 'Laden...',
    anonymous: 'Anonym',
    noScoresYet: 'Noch keine Punkte',
    errorLoading: 'Fehler beim Laden der Bestenliste',
  },
  pt: {
    header: 'Placar de líderes',
    subtitle: 'Veja como seu círculo está crescendo',
    scope: 'Seu círculo',
    timePeriod: 'Período',
    global: 'Global',
    church: 'Igreja',
    family: 'Família',
    friends: 'Amigos',
    alltime: 'Todos os tempos',
    weekly: 'Semanal',
    loading: 'Carregando...',
    anonymous: 'Anônimo',
    noScoresYet: 'Ainda sem pontuações',
    errorLoading: 'Erro ao carregar placar',
  },
  ru: {
    header: 'Таблица лидеров',
    subtitle: 'Смотрите, как растёт ваш круг',
    scope: 'Ваш круг',
    timePeriod: 'Период',
    global: 'Глобальная',
    church: 'Церковь',
    family: 'Семья',
    friends: 'Друзья',
    alltime: 'За все время',
    weekly: 'Еженедельно',
    loading: 'Загрузка...',
    anonymous: 'Анонимный',
    noScoresYet: 'Пока нет очков',
    errorLoading: 'Ошибка загрузки таблицы лидеров',
  },
  tl: {
    header: 'Leaderboard',
    subtitle: 'Tingnan kung paano lumalaki ang iyong grupo',
    scope: 'Iyong grupo',
    timePeriod: 'Panahon',
    global: 'Global',
    church: 'Simbahan',
    family: 'Pamilya',
    friends: 'Mga kaibigan',
    alltime: 'Lahat ng oras',
    weekly: 'Lingguhan',
    loading: 'Naglo-load...',
    anonymous: 'Hindi kilala',
    noScoresYet: 'Walang scores pa',
    errorLoading: 'May error sa pag-load ng leaderboard',
  },
  it: {
    header: 'Classifica',
    subtitle: 'Guarda come cresce il tuo gruppo',
    scope: 'Il tuo gruppo',
    timePeriod: 'Periodo',
    global: 'Globale',
    church: 'Chiesa',
    family: 'Famiglia',
    friends: 'Amici',
    alltime: 'Tutti i tempi',
    weekly: 'Settimanale',
    loading: 'Caricamento...',
    anonymous: 'Anonimo',
    noScoresYet: 'Nessun punteggio ancora',
    errorLoading: 'Errore nel caricamento classifica',
  },
  am: {
    header: 'የአመራር ሰሌዳ',
    subtitle: 'ቡድንዎ እንዴት እያደገ እንደሆነ ይመልከቱ',
    scope: 'የእርስዎ ቡድን',
    timePeriod: 'ጊዜ',
    global: 'ዓለም አቀፍ',
    church: 'ቤተክርስቲያን',
    family: 'ቤተሰብ',
    friends: 'ጓደኞች',
    alltime: 'ሁሉም ጊዜ',
    weekly: 'ሳምንታዊ',
    loading: 'እየጫነ...',
    anonymous: 'ሳያውቁ',
    noScoresYet: 'ገና ውጤት የለም',
    errorLoading: 'የአመራር ሰሌዳ ጫኝ ስህተት',
  },
  ko: {
    header: '리더보드',
    subtitle: '당신의 그룹이 어떻게 성장하는지 보세요',
    scope: '나의 그룹',
    timePeriod: '기간',
    global: '글로벌',
    church: '교회',
    family: '가족',
    friends: '친구',
    alltime: '전체 기간',
    weekly: '주간',
    loading: '로딩 중...',
    anonymous: '익명',
    noScoresYet: '아직 점수 없음',
    errorLoading: '리더보드 로드 오류',
  },
};
